import { GlobalIntegration } from '@omnea-app/config/globalIntegrations'
import { CreditsafeQuestionIdsArray } from './creditsafe'
import { ThomsonReutersQuestionIdsArray } from './thomsonReuters'
import { TprmContinuousMonitoringQuestionIdsArray } from './tprmContinuousIntegration'
import { TropicQuestionIdsArray } from './tropic'

export const getProtectedExtOpsQuestionIds = (integration: GlobalIntegration | undefined): string[] => {
  switch (integration) {
    case 'creditsafe':
      return CreditsafeQuestionIdsArray
    case 'thomson-reuters':
      return ThomsonReutersQuestionIdsArray
    case 'tprm-continuous-monitoring':
      return TprmContinuousMonitoringQuestionIdsArray
    case 'tropic':
      return TropicQuestionIdsArray
    default:
      return []
  }
}
